import * as React from "react";
import { api } from "@repo/convex/convex/_generated/api";
import { PageHeader } from "../common/PageHeader.tsx";
import { usePaginatedItems } from "../common/hooks.ts";
import { ItemsScrollArea } from "../common/items/ItemsScrollArea.tsx";
import { useQuery } from "convex-helpers/react/cache/hooks";
import { TrashedItemDoc } from "@repo/convex/convex/schema.ts";
import { TrashedItem } from "./TrashedItem.tsx";
import { ListedItem } from "@repo/convex/convex/items.ts";
import { EmptyTrashButton } from "./EmptyTrashButton.tsx";

interface Props {
  children?: React.ReactNode;
}

export const TrashPage: React.FC<Props> = ({}) => {
  const { status, loadMore, isLoading, items } = usePaginatedItems({
    statusKind: "trashed",
  });
  const count = useQuery(api.items.count, { statusKind: "trashed" });

  return (
    <>
      <PageHeader
        title="Trash"
        subtitle={binned(count)}
        actions={count ? <EmptyTrashButton count={count} /> : null}
      />
      <ItemsScrollArea
        items={items}
        isLoading={isLoading}
        empty={{
          title: "The bin's empty",
          detail: "Things you bin stay here for 30 days, in case you change your mind.",
        }}
        renderItem={(item) => (
          <TrashedItem key={item._id} item={item as ListedItem<TrashedItemDoc>} />
        )}
        onLoadMore={() => loadMore(20)}
        canLoadMore={status == "CanLoadMore"}
      />
    </>
  );
};

const binned = (count: number | undefined) => {
  if (count === undefined) return "\u00a0";
  if (count == 0) return "nothing in it";
  if (count == 1) return "1 thing, kept for 30 days";
  return `${count >= 500 ? "500+" : count} things, each kept for 30 days`;
};
